<template>
  <div>
    {{timestamp | since}}
  </div>
</template>

<script>
import moment from 'moment';

let interval = null;

export default {
  name: 'VMomentRefresh',
  props: {
    interval: {
      type: Number,
      required: false,
      default: 5,
    },
    timestamp: {
      type: Number,
      required: true,
    },
  },
  mounted() {
    interval = setInterval(() => {
      this.$forceUpdate();
    }, 5000);
  },
  beforeDestroy() {
    try {
      clearInterval(interval);
    } catch (e) {} // eslint-disable-line
  },
  filters: {
    since(epoch) {
      if (epoch === 0) { // Don't return if unix timestamp === 0
        return '-';
      }
      return moment(epoch, 'X').fromNow();
    },
  },
};
</script>
